export function timeFunction(time) {
  // 公共方法的实现
  var date = new Date(time);
  var Y = date.getFullYear();
  var M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  // if (hsm) {
  //   this.countdown.hour = date.getHours();
  //   this.countdown.second = date.getMinutes();
  //   this.countdown.min = date.getSeconds();
  //   this.countTime();
  // }

  return `${D}/${M}/${Y}`;
}

export function addComma(num = 0) {
  if (num || num == 0) {
    return num.toString().replace(/\d+/, function(n) {
      return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    });
  }
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return '';
}
